// extracted by mini-css-extract-plugin
export default {"service-list":"Ec_8ApKuuUodOp-TO3OHJ"};